import { BundleType } from 'swag-common/constants/main-swag.constants';
export const replaceCDNToOrigin = url => {
  const parsedUrl = new URL(url);
  const pathname = String(parsedUrl.pathname).replace(`${BundleType.DYNAMIC}/`, '');
  const sameOriginWorkerUrl = new URL(pathname, globalThis.location.origin);
  return sameOriginWorkerUrl;
};